export default {"src":"/_next/static/media/JETS.1f211ac3.svg","height":18,"width":18};